/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Security_Transit_LabelInputs */

const es_privacy_policy_security_transit_label = /** @type {(inputs: Privacy_Policy_Security_Transit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cifrado en Transito`)
};

const en_privacy_policy_security_transit_label = /** @type {(inputs: Privacy_Policy_Security_Transit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encryption in Transit`)
};

/**
* | output |
* | --- |
* | "Encryption in Transit" |
*
* @param {Privacy_Policy_Security_Transit_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_security_transit_label = /** @type {((inputs?: Privacy_Policy_Security_Transit_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Security_Transit_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_security_transit_label(inputs)
	return en_privacy_policy_security_transit_label(inputs)
});
export { privacy_policy_security_transit_label as "privacy_policy.security.transit_label" }